export function Syntax(Az) {
  var Syntax = function() {};

  return Syntax;
}
